import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { authService, UserRole } from '../services/authService';

interface ProtectedRouteProps {
  redirectPath?: string;
  allowedRoles?: UserRole[];
}

/**
 * ProtectedRoute component that checks if user is authenticated and has required roles
 * Redirects to login page if not authenticated
 * Redirects to unauthorized page if user doesn't have required roles
 */
export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  redirectPath = '/login',
  allowedRoles
}) => {
  const isAuthenticated = authService.isAuthenticated();
  
  // If not authenticated, redirect to login page
  if (!isAuthenticated) {
    return <Navigate to={redirectPath} replace />;
  }

  // If roles are specified, check if user has any of the allowed roles
  if (allowedRoles && allowedRoles.length > 0) {
    const hasRequiredRole = authService.hasAnyRole(allowedRoles);
    
    if (!hasRequiredRole) {
      // Redireciona para rota raiz, que aplica redirecionamento por perfil sem loop de rota
      return <Navigate to="/" replace />;
    }
  }

  // If authenticated and has required role (if specified), render the child routes
  return <Outlet />;
};
